<app-modals [title]="title" [description]="description" [openModal]="openModal" [closeModal]="closeModal" [whenModalClose]="whenModalClose" [submitKey]="submitKey" [invalidFormGroup]="$safeNavigationMigration(entry?.invalid)" [isButtonsDisabled]="isButtonsDisabled" [onDismiss]="onDismiss" [showFooter]="false">
  <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit()" novalidate="novalidate">
    @if (isConfirm) {
      <div class="alert alert-warning fadeIn">
        @if (bulk?.length > 0) {
          <p [innerHTML]="'MODALS.REMINDERS.CONFIRM.DESCRIPTION' | translate : { totalReminders: $safeNavigationMigration(bulk?.length), type: type }"></p>
        }
        @if (bulk?.length === 0) {
          <p [innerHTML]="'MODALS.REMINDERS.CONFIRM.NO_REMINDERS' | translate"></p>
        }
        <div class="row">
          <div class="col-12">
            <div class="btn-toolbar ms-auto me-0"><button class="btn btn-outline" type="button" (click)="toggleConfirm()">{{ 'BUTTONS.CANCEL' | translate }}</button>@if (bulk?.length > 0) {
            <button class="btn v-btn-primary" type="submit">{{ 'BUTTONS.SUBMIT' | translate }}</button>
          }</div>
        </div>
      </div>
    </div>
    }@if (!isConfirm) {
    <app-table [cols]="cols" [rows]="rows" [onRowClick]="onRowClick"></app-table>
  }
</form>
</app-modals>
